import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueAwesomePaginate from "vue-awesome-paginate";
import helper from "./helper";
import VueDatePicker from '@vuepic/vue-datepicker';


const pepollApp = createApp(App);
pepollApp.use(store).use(router).use(VueAwesomePaginate);
pepollApp.config.globalProperties.$helper=helper;
pepollApp.component('VueDatePicker', VueDatePicker);



pepollApp.mount("#app");
import "bootstrap/dist/css/bootstrap.min.css"
import "@/assets/css/reset.css";
import "@/assets/css/base.css";
import "@/assets/css/fonts.css"
import "bootstrap/dist/js/bootstrap.bundle.js"
import "@vueform/multiselect/themes/default.css"
import "vue-awesome-paginate/dist/style.css";
import '@vuepic/vue-datepicker/dist/main.css'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
